import { render, staticRenderFns } from "./TheLayoutToolbar.vue?vue&type=template&id=72737972"
import script from "./TheLayoutToolbar.vue?vue&type=script&lang=js"
export * from "./TheLayoutToolbar.vue?vue&type=script&lang=js"
import style0 from "./TheLayoutToolbar.vue?vue&type=style&index=0&id=72737972&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports